import React from "react";
import { Navigate, Route, Routes, useParams } from "react-router-dom";
import All from "./all";
import OrdersWrapper from "./all/OrdersWrapper";
import OrderPickingWrapper from "./orderpicking/OrderPickingWrapper";
import OrderDetailWrapper from "./orderpicking-detail/OrderDetailWrapper";
import ProtectedRoute from "../../../components/util-components/ProtectedRoute";

const PARENT_URL = "/cms/orders";

// Wrapper component to extract companyType parameter
const OrdersWrapperWithParams = () => {
  const { companyType } = useParams();
  return (
    <ProtectedRoute routeKey={`shop-orders-${companyType}`}>
      <OrdersWrapper />
    </ProtectedRoute>
  );
};

// Wrapper component for orderpicking with companyType parameter
const OrderPickingWrapperWithParams = () => {
  const { companyType } = useParams();
  return (
    <ProtectedRoute routeKey={`shop-orders-orderpicking-${companyType}`}>
      <OrderPickingWrapper />
    </ProtectedRoute>
  );
};

// Wrapper component for orderpicking detail with companyType parameter
const OrderDetailWrapperWithParams = () => {
  const { companyType } = useParams();
  return (
    <ProtectedRoute routeKey={`shop-orders-orderpicking-${companyType}`}>
      <OrderDetailWrapper />
    </ProtectedRoute>
  );
};

const Orders = () => {
  return (
    <Routes>
      <Route
        path={`/orders`}
        element={
          <ProtectedRoute routeKey={"shop-orders-all"}>
            <All />
          </ProtectedRoute>
        }
      />
      <Route path={`/orderpicking/:companyType/detail/:orderId`} element={<OrderDetailWrapperWithParams />} />
      <Route path={`/orderpicking/:companyType`} element={<OrderPickingWrapperWithParams />} />
      <Route path={`/:companyType`} element={<OrdersWrapperWithParams />} />
      <Route path={``} element={<Navigate to={`${PARENT_URL}/orders`} replace />} />
    </Routes>
  );
};

export default Orders;
